module.exports = __webpack_public_path__ + "img/login_bg_pc.70fd7505.png";